function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "return-arrow");

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.64,
    height: 14.55,
    viewBox: "0 0 14.64 14.55"
  }, props), _ref, /*#__PURE__*/React.createElement("polygon", {
    points: "14.64 4.47 8.29 4.47 8.29 0 0 7.13 8.29 14.55 8.29 10.19 14.64 10.19 14.64 4.47",
    style: {
      "fill": "#5481a3"
    }
  }));
};

export default __webpack_public_path__ + "static/media/return-arrow.042aab55.svg";
export { SvgComponent as ReactComponent };